export default "__VITE_ASSET__9135a94b__"